import { IExtendedRootScopeService } from "./../../../ng-extensions/models";
import { UIErrorHandlingService } from "./../../../../error-handling/services/error-handling-service";
import { IAssigneesStoreState, IAssignee, AssigneeActions } from "@gtmhub/assignees";
import { GtmhubController } from "@gtmhub/core";
import { INgRedux } from "@gtmhub/state-management";
import { IdMap } from "@gtmhub/util";
import { IComponentOptions, IScope } from "angular";
import { IUIError } from "@gtmhub/error-handling";

interface ITeamDropdownBindings {
  ids: string[];
}

interface ITeamDropdownComponentRedux {
  assignees: IdMap<IAssignee>;
  reduxItemsFetched: boolean;
  reduxItemsError: IUIError;
}

const bindStateToCtrl = (state: IAssigneesStoreState) => {
  const { map: assignees, isFetched: assigneesFetched, error: assigneesError } = state.assignees;

  return {
    assignees: assignees,
    reduxItemsFetched: assigneesFetched,
    reduxItemsError: assigneesError,
  };
};

/**
 * @example <teams-with-dropdown ids="goal.ownerIds"></teams-with-dropdown>
 * @param ids string[]
 */

export interface ITeamDropdownDropdownCtrlScope extends IExtendedRootScopeService, IScope, ITeamDropdownComponentRedux {}
export interface TeamDropdownCtrl extends ITeamDropdownBindings, ITeamDropdownComponentRedux {}
export class TeamDropdownCtrl extends GtmhubController {
  static $inject = ["$scope", "$ngRedux", "AssigneeActions", "UIErrorHandlingService"];

  constructor(
    private $scope: ITeamDropdownDropdownCtrlScope,
    private $ngRedux: INgRedux,
    private assigneeActions: AssigneeActions,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    super();

    this.onDestroy($ngRedux.connect(bindStateToCtrl)(this));
    $ngRedux.dispatch(assigneeActions.getAssignees());
  }

  $onInit(): void {
    this.$ngRedux.dispatch(this.assigneeActions.getAssignees());

    this.$scope
      .watchUntilAndRejectOnError(
        () => this.reduxItemsFetched,
        () => this.reduxItemsError
      )
      .then(
        () => {
          this.ids = this.ids?.filter((id) => this.assignees[id]);
        },
        (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "loading", inline: false })
      );
  }
}

export const TeamsWithDropdownComponent: IComponentOptions = {
  controller: TeamDropdownCtrl,
  templateUrl: require("./teams-with-dropdown.jade"),
  transclude: true,
  bindings: {
    ids: "<",
  },
};
